import { cleanQueryRedirect } from '#pplx/frontend/auth/utils/cleanQueryRedirect.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { LOGIN_SOURCE_PARAM } from '#pplx/frontend/components/utils/consts.js';
export const getIsGrowCometStudentOnboardingFromRedirectUrl = ({ searchParams, cleanRedirect, }) => {
    if (!searchParams) {
        return null;
    }
    const rawRedirect = searchParams.get('redirect');
    const redirectUrl = cleanRedirect
        ? cleanQueryRedirect({
            redirect: rawRedirect,
        })
        : rawRedirect;
    let loginSource = null;
    try {
        loginSource = redirectUrl && new URL(redirectUrl).searchParams.get(LOGIN_SOURCE_PARAM);
    }
    catch {
        // not a valid redirect url
        return null;
    }
    if (!loginSource) {
        return null;
    }
    if (loginSource === ModalOrigin.GROW_COMET_STUDENTS_COUNTRY) {
        return ModalOrigin.GROW_COMET_STUDENTS_COUNTRY;
    }
    if (loginSource === ModalOrigin.GROW_COMET_STUDENTS) {
        return ModalOrigin.GROW_COMET_STUDENTS;
    }
    return null;
};
//# sourceMappingURL=studentUtils.js.map